export const ArrowButtonIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" transform="rotate(-180 8 8)" />
      <path d="M4 10L8.19048 6L12 10" stroke="white" strokeWidth="2" />
    </svg>
  );
};
